const isIE =
  window.navigator.userAgent.indexOf("MSIE") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
export const environment = {
  production: true,
  adalConfig: {
    tenant: "chevron.onmicrosoft.com",
    clientId: "f9bd995f-3f53-445b-896a-5549328fd36a",
    postLogoutRedirectUri: "http://localhost:44300/logout",
    endpoints: {
      "https://chevron.onmicrosoft.com/e915774d-b77c-4155-b0f3-dfd7a9413885":
        "https://chevron.onmicrosoft.com/e915774d-b77c-4155-b0f3-dfd7a9413885",
    },
  },
  msalConfig: {
    auth: {
      clientId: "f9bd995f-3f53-445b-896a-5549328fd36a",
      authority:
        "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/",
      validateAuthority: true,
      redirectUri: "https://tap-dr.azure.chevron.com/",
      postLogoutRedirectUri: "https://tap-dr.azure.chevron.com/logout",
      navigateToLoginRequestUrl: true,
      user_impersonation:
        "https://turnaroundms-prod.azure.chevron.com/user_impersonation",
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    angular: {
      popUp: false,
      consentScopes: ["user.read", "openid", "profile"],
      protectedResourceMap: [
        ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
      ],
      extraQueryParameters: {},
    },
  },
  oktaConfig: {
    clientId: "0oa1w8tl0nm4FQ20p1d8",
    issuer: "https://cvxportal.okta.com/oauth2/default",
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ["openid", "profile", "email", "offline_access"],
  },
  TCOInstanceId: ["2"],
  appCode: "webApp",
  internalDomains: [
    "chevron.com",
    "tengizchevroil.com",
    "chevron.onmicrosoft.com",
    "alngopco.com",
  ],
  apiEndpoint: "https://mobileturnaround-api-prod-dr-cvx.azurewebsites.net/api",
  useAppInsights: true,
  appInsightsConnectionString: process.env["NG_APP_INSIGHTS_CONN_STRING"],
};